module.exports = __webpack_public_path__ + "img/6.db368a38.jpg";